import { useMemo } from 'react';
import { type RouteObject, useLocation } from 'react-router';
import { Divider, Grid, Typography } from '@mui/material';

import { Breadcrumbs } from '~/components/Breadcrumbs';
import { router } from '../../router';

export const PageHeader = () => {
    const { pathname } = useLocation();

    const { Title, title } = useMemo(
        () => router.state.matches
            .map((match): RouteObject => match.route as RouteObject)
            .filter(route => route.title)
            .pop() || {},
        [pathname]
    );

    return (
        <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
            <Breadcrumbs />
            {(Title || title) && <Typography variant="h2">
                {Title ? <Title /> : title}
            </Typography>}
            <Divider sx={{ mt: 2 }} />
        </Grid>
    );
};
